import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { RestService } from "src/app/services/rest.service";
import { NzNotificationService } from "ng-zorro-antd/notification";
import { StateService } from "src/app/services/state.service";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
})
export class LoginComponent implements OnInit {
  validateForm: FormGroup;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    public _state: StateService,
    private _rest: RestService,
    private _notify: NzNotificationService
  ) {}

  submitForm(): void {
    for (const i in this.validateForm.controls) {
      this.validateForm.controls[i].markAsDirty();
      this.validateForm.controls[i].updateValueAndValidity();
    }
    if (this.validateForm.valid) {
      this._rest.login(this.validateForm.value).subscribe(
        (resp) => {
          console.log(resp);
          this._notify.create("success", "success", "Welcome");
          localStorage.setItem("token", resp["RESULT"]["token"]);
          this._state.isLogin = true;
          this.router.navigate(["/user"]);
          window.location.reload();
        },
        (err) => {
          console.log(err);
          this._notify.create("error", "error", "Error to login");
        }
      );
    }
  }

  ngOnInit(): void {
    this, this._state.validateLogin();
    if (this._state.isLogin) {
      this.router.navigate(["/user"]);
    }
    this.validateForm = this.fb.group({
      username: ["", [Validators.required]],
      password: ["", [Validators.required]],
    });
  }
}
